import { call } from '../../utils/serviceUtils';
import {
  PROCESS_TYPE_GET,
  PROCESS_TYPE,
  PROCESS_TYPE_GET_BY_GROUP_ID
  } from '../../config/paths';


export function getProcessTypes() {
  return call.get(PROCESS_TYPE_GET,
    {

    });
}

export function getProcessType(groupId) {
  return call.get(PROCESS_TYPE_GET_BY_GROUP_ID+'/'+groupId,
    {

    });
}	

export function deleteProcessTypeById(id) {
  return call.delete(PROCESS_TYPE+'/'+id,
  {
    
  });
}

export function createProcessType(data) {
  return call.post(PROCESS_TYPE,data);
}

export function updateProcessType(id,data) {
  return call.put(PROCESS_TYPE+'/'+id,data);
}


